import React from 'react';
import { stats } from '../data/kit';
export function StatsBar() {
  return <section aria-label="Resultados del Kit Yoga Lista" className="py-8 border-y border-brand-creamDark bg-white/60" data-id="element-136" data-mp="1tai33ccd4vrv">
      <div className="max-w-5xl mx-auto px-4" data-id="element-137" data-mp="1oaca9sucx387">
        <dl className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center md:divide-x md:divide-brand-creamDark" data-id="element-138" data-mp="1od86ncqk3juj">
          {stats.map(stat => <div key={stat.label} className="flex flex-col items-center justify-center" data-id="element-139" data-mp="1ee96yjnrqyjo">
              <dt className="order-2 text-xs md:text-sm text-brand-gray uppercase tracking-wider font-medium" data-id="element-140" data-mp="19l7qw8btssyi">
                {stat.label}
              </dt>
              <dd className="order-1 text-3xl md:text-4xl font-serif font-bold text-brand-text mb-1" data-id="element-141" data-mp="10mlzrosag5m4">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}